import React, { Component, ErrorInfo, ReactNode } from 'react'

interface Props {
  children: ReactNode
}

interface State {
  hasError: boolean
  error: Error | null
  errorInfo: ErrorInfo | null
}

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      hasError: false,
      error: null,
      errorInfo: null
    }
  }

  static getDerivedStateFromError(error: Error): State {
    return {
      hasError: true,
      error,
      errorInfo: null
    }
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('Error caught by boundary:', error, errorInfo)
    this.setState({
      error,
      errorInfo
    })
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: '40px', fontFamily: 'Arial', maxWidth: '800px', margin: '0 auto' }}>
          <h1 style={{ color: '#ef4444', marginBottom: '20px' }}>❌ Application Error</h1>
          <div style={{ background: '#fee2e2', padding: '20px', borderRadius: '8px', marginBottom: '20px' }}>
            <h2 style={{ color: '#991b1b', marginBottom: '10px' }}>Something went wrong</h2>
            <p style={{ marginBottom: '10px' }}>The application encountered an error:</p>
            <pre style={{ background: '#fff', padding: '15px', borderRadius: '4px', overflow: 'auto', fontSize: '12px' }}>
              {this.state.error?.toString()}
            </pre>
          </div>
          {this.state.errorInfo && (
            <div style={{ background: '#fef3c7', padding: '20px', borderRadius: '8px' }}>
              <h3 style={{ color: '#92400e', marginBottom: '10px' }}>Stack Trace:</h3>
              <pre style={{ background: '#fff', padding: '15px', borderRadius: '4px', overflow: 'auto', fontSize: '11px', maxHeight: '300px' }}>
                {this.state.errorInfo.componentStack}
              </pre>
            </div>
          )}
          <button 
            onClick={() => window.location.reload()}
            style={{
              marginTop: '20px',
              padding: '10px 20px',
              background: '#0ea5e9',
              color: '#fff',
              border: 'none',
              borderRadius: '6px',
              cursor: 'pointer',
              fontSize: '14px'
            }}
          >
            Reload Page
          </button>
        </div>
      )
    }

    return this.props.children
  }
}
